import { IProductVariant } from "@/interfaces/product";
import { QuickInfo } from "@/components/Pages/CategoryListPage";
import { ProductGallery } from "@/components/Pages/ProductDetailPage";
import { useState } from "react";

interface QuickViewProps {
  productVariants: IProductVariant[];
  link: string;
}

const QuickView: React.FC<QuickViewProps> = (props) => {
  const { productVariants, link } = props;
  const [selectedVariant, setSelectedVariant] = useState<IProductVariant>(
    productVariants[0],
  );
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-8">
      <div>
        <ProductGallery
          productVariants={productVariants}
          selectedVariant={selectedVariant}
        />
      </div>
      <div>
        <QuickInfo
          productVariants={productVariants}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          link={link}
        />
      </div>
    </div>
  );
};

export default QuickView;
